require("../../../static/js/video/video-block.js");
